<div class="upperSection">
  <div class="menuTitleWithExit">
    <div class="menuTitle" style="padding-top: 11px">
      <div class="title">Placemark List</div>
    </div>
    <div class="menuTitle exitMenu">
      <mat-icon class="closeIcon" svgIcon="panel.close" (click)="closePanel.emit()"></mat-icon>
    </div>
  </div>
  <div class="searchContainer">
    <input class="searchField" type="text" [(ngModel)]="filterStr" placeholder="Search">
    @if (filterStr !== '') {
      <div class="clearButton" (click)="clearFilterStr()">clear</div>
    }
    <mat-icon class="searchIcon" svgIcon="sites.search"></mat-icon>
  </div>
</div>
<div class="middleSection" [class.noContent]="getPlacemarks().length === 0">
  @if (getPlacemarks().length === 0) {
    <div class="noContentAvailable">{{noContentAvailableStr}}</div>
  }
  @if (getPlacemarks().length !== 0) {
    <perfect-scrollbar>
      @for (placemark of getPlacemarks(); track trackByPlacemarkId($index, placemark)) {
        <div class="outerEntry" (click)="displayResultOnGraphic(placemark)" (dblclick)="openPlacemark(placemark)">
          <img class="placemarkIcon" [src]="getPlacemarkIcon(placemark) | safe" alt="placemark icon">
          <div class="pmTitle" #placemarkName insTooltip [cfg]="getToolTipConf(placemarkName, placemark.name)">{{ placemark.name }}</div>
        </div>
      }
    </perfect-scrollbar>
  }
</div>
